/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.models {

    export class ObjectQueryFormModelApi {
        id: string;
        uniqueIdentifier: string;
        processConfigurationId: string;
        formId: string;
        queryId: string;
        alwaysShowListsExpanded: boolean;
        disableSort: boolean;
        disableFilter: boolean;
        objectQueryFormSchemaProperties: Array<ObjectQueryFormSchemaProperty>;
        objectQueryResultSets: any;
    }

    export class ObjectQueryFormSchemaProperty {
        id: string;
        name: string;
        querySchemaPropertyId: string;
        formSchemaPropertyId: string;
        schemaProperties: Array<services.ObjectQueryApiSchemaProperty>;
    }

    export class ObjectQueryGroupCondition {
        id: string;
        name: string;
    }

    export class ObjectQueryResultProperty {
        id: string;
        columnName: string;
        includeIf: boolean;
        conditionId: string;
        exportOnly: boolean;
        columnOrder: number;
        querySchemaPropertyId: string;
        conditions: Array<ObjectQueryGroupCondition>;
        resultProperties: Array<services.ObjectQueryApiSchemaProperty>;
    }

    export class ObjectQueryFormModel {

        private currentTreeItem: models.TreeConfigurationItem;
        private systemLevel: Wars.Domain.Model.SystemLevel;
        private processConfigurationId: string;
        private newObjectQueryName = "";
        private existingObjectQueries: Array<Wars.Domain.Model.ObjectQuery>;
        private existingCodes: Array<Wars.Domain.Model.Codes.CodeGroup>;
        private showOnTree: string;
        private displayTree: boolean;

        private objectQueryFormApiQueries: Array<services.ObjectQueryFormApiQuery>;
        private objectQueryFormApiForms: Array<services.ObjectQueryFormApiForm>;
        private currentApi: ObjectQueryFormModelApi;

        public constructor(
            private scope: angular.IScope,
            private qService: angular.IQService,
            private growlService: angular.growl.IGrowlService,
            private $routeParams: angular.route.IRouteParamsService,
            private systemLevelService: services.SystemLevelService,
            private treeService: services.TreeService,
            private objectQueryService: services.ObjectQueryService) {
            var self = this;
            self.processConfigurationId = $routeParams["id"];
            self.currentApi = new ObjectQueryFormModelApi();
            self.objectQueryService.getObjectQueryFormApiForms(self.processConfigurationId)
                .then((result) => {
                    self.objectQueryFormApiForms = result;
                    self.objectQueryService.getObjectQueryFormApiQueries(self.processConfigurationId)
                        .then((result2) => {
                        self.objectQueryFormApiQueries = result2;
                            self.getCurrentApi();
                        });
                });
        }

        getCurrentApi() {
            var self = this;
            self.objectQueryService.getQueryApi(self.processConfigurationId)
                .then((result) => {
                    if (result != null) {
                        self.currentApi = result;
                        var currentMapping = self.currentApi.objectQueryFormSchemaProperties; 
                        self.currentApi.objectQueryFormSchemaProperties = self.getFormProperties();
                        self.remap(currentMapping, self.currentApi.objectQueryFormSchemaProperties);
                    }
                });
        }
  
        saveQueryApi() {
            var self = this;
            self.currentApi.processConfigurationId = self.processConfigurationId;
            self.objectQueryService.saveQueryApi(self.currentApi).then(() => {
                self.getCurrentApi();
                var currentMapping = self.currentApi.objectQueryFormSchemaProperties;
                self.currentApi.objectQueryFormSchemaProperties = self.getFormProperties();
                self.remap(currentMapping, self.currentApi.objectQueryFormSchemaProperties);
            });
        }

        remap(currentMapping: Array<ObjectQueryFormSchemaProperty>, binding: Array<ObjectQueryFormSchemaProperty>) {
            if (binding != null && binding.length != null) {
                for (var x = 0; x < binding.length; x++) {
                    var c = Enumerable.from(currentMapping)
                        .where(i => i.formSchemaPropertyId === binding[x].formSchemaPropertyId)
                        .firstOrDefault();
                    if (c != null) {
                        binding[x].id = c.id;
                        binding[x].querySchemaPropertyId = c.querySchemaPropertyId;
                    }
                }    
            }
        }

        removeQueryApi() {
            var self = this;
            self.objectQueryService.removeQueryApi(self.currentApi).then(() => {
                self.currentApi = new ObjectQueryFormModelApi();
            });
        }

        getFormProperties() {
            var self = this;
            var form = Enumerable.from(self.objectQueryFormApiForms)
                .where(i => i.id === self.currentApi.formId)
                .firstOrDefault();
            if (form == null) return null;
            var result = self.getSchemaProperties(form.schemaProperties);
            return result;
        }

        getSchemaProperties(schemaProperties: Array<services.ObjectQueryApiSchemaProperty>): Array<ObjectQueryFormSchemaProperty> {
            var self = this;
            var properties = new Array<ObjectQueryFormSchemaProperty>();
            for (var x = 0; x < schemaProperties.length; x++) {
                if (schemaProperties[x].variableType === Wars.Domain.Model.Codes.Enums.VariableType.Object) {
                    var range = self.getSchemaProperties(schemaProperties[x].schemaProperties);
                    if (range.length > 0) {
                        properties.addRange(range);    
                    }
                } else {
                    var property = new ObjectQueryFormSchemaProperty();
                    property.name = schemaProperties[x].name;
                    property.formSchemaPropertyId = schemaProperties[x].id;
                    var q = Enumerable.from(self.objectQueryFormApiQueries)
                        .where(i => i.id === self.currentApi.queryId)
                        .firstOrDefault();
                    if (q != null) { 
                        if (schemaProperties[x].variableType === Wars.Domain.Model.Codes.Enums.VariableType.Boolean) {
                            property.schemaProperties = Enumerable.from(q.schemaProperties).where(i => i.variableType === Wars.Domain.Model.Codes.Enums.VariableType.Boolean || i.variableType === Wars.Domain.Model.Codes.Enums.VariableType.User).toArray();
                        } else if (schemaProperties[x].variableType === Wars.Domain.Model.Codes.Enums.VariableType.MultiSelectStatus) {
                            property.schemaProperties = Enumerable.from(q.schemaProperties).where(i => i.variableType === Wars.Domain.Model.Codes.Enums.VariableType.Object || i.variableType === Wars.Domain.Model.Codes.Enums.VariableType.Status).toArray();
                        } else if (schemaProperties[x].variableType === Wars.Domain.Model.Codes.Enums.VariableType.MultiSelectState) {
                            property.schemaProperties = Enumerable.from(q.schemaProperties).where(i => i.variableType === Wars.Domain.Model.Codes.Enums.VariableType.Object || i.variableType === Wars.Domain.Model.Codes.Enums.VariableType.State).toArray();
                        } else if (schemaProperties[x].variableType === Wars.Domain.Model.Codes.Enums.VariableType.Date || schemaProperties[x].variableType === Wars.Domain.Model.Codes.Enums.VariableType.DateTime) {
                            property.schemaProperties = Enumerable.from(q.schemaProperties).where(i => i.variableType === Wars.Domain.Model.Codes.Enums.VariableType.Date || i.variableType === Wars.Domain.Model.Codes.Enums.VariableType.DateTime).toArray();
                        } else if (schemaProperties[x].variableType === Wars.Domain.Model.Codes.Enums.VariableType.String) {
                            property.schemaProperties = Enumerable.from(q.schemaProperties).where(i => i.variableType === schemaProperties[x].variableType
                                || i.variableType === Wars.Domain.Model.Codes.Enums.VariableType.ReviewConfiguration
                                || i.variableType === Wars.Domain.Model.Codes.Enums.VariableType.Claim).toArray();
                        } else {
                            property.schemaProperties = Enumerable.from(q.schemaProperties).where(i => i.variableType === schemaProperties[x].variableType).toArray();
                        }
                        
                        properties.push(property);
                    }
                }
            }
            return properties;
        }

        addResultMapping(mapSet: any) {
            var self = this;
            self.objectQueryService.addQueryResultMapping(self.currentApi, mapSet).then((result) => {
                if (mapSet.resultMappings == null) {
                    mapSet.resultMappings = new Array<ObjectQueryResultProperty>();
                }
                mapSet.resultMappings.push(result);
            });
        }

        removeResultMapping(mapping: ObjectQueryResultProperty, mapSet: any) {
            var self = this;
            self.objectQueryService.removeResultMapping(mapping, mapSet).then((result) => {
                self.currentApi.objectQueryResultSets = result;
            });
        }

        saveResultMapping(mapping: ObjectQueryResultProperty) {
            var self = this;
            self.objectQueryService.saveResultMapping(mapping).then(() => {

            });
        }

        changeResultMappingOrder(mapping: ObjectQueryResultProperty, ascending: boolean, mapSet: any) {
            var self = this;
            self.objectQueryService.reorderResultMapping(mapping, ascending, mapSet).then((result) => {
                self.currentApi.objectQueryResultSets = result;
            });
        }

        saveMapSet(mapSet: any) {
            var self = this;
            self.objectQueryService.saveMapSet(mapSet).then(() => {
                
            });
        }

        updateMapSetOrder(mapSet: any, ascending: boolean) {
            var self = this;
            self.objectQueryService.updateMapSetOrder(mapSet, ascending).then((result) => {
                self.currentApi.objectQueryResultSets = result;
            });
        }

    }
}